import { motion } from "framer-motion";
import { PropsWithClassName, cn } from "kz-ui-sdk";
import React from "react";
import { borderVariant } from "../utils"; // Only needs the variant

interface MegaShareBackgroundProps extends PropsWithClassName {
  children: React.ReactNode;
  zIndex: number;
}

const MegaShareBackground = ({ className, children, zIndex }: MegaShareBackgroundProps) => {
  return (
    <div
      className={cn(
        "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
        "h-[84px] w-[84px] overflow-hidden rounded-full",
        "flex items-center justify-center font-bold",
        className,
      )}
      style={{ zIndex }}
    >
      <motion.img
        src="/images/mega-share/circle-border.png"
        className="absolute z-[1] h-full w-full"
        variants={borderVariant}
      />
      <motion.div
        className="absolute z-[3] h-full w-full bg-[linear-gradient(to_bottom,transparent_60%,rgba(51,13,87,0.7)_100%)]"
        variants={borderVariant}
      />
      <div className="relative flex h-[74px] w-[74px] items-center justify-center overflow-hidden rounded-full">
        {children}
      </div>
    </div>
  );
};

export default MegaShareBackground;
